export const API_CODES = Object.freeze({
  INVALID_REQUEST: -1001,
  NOT_AUTHENTICATED: -1002,
  INTENT_NOT_FOUND: -1004,
  PHONE_IDENTITY_REQUIRED: -1032,
  KYC_REQUIRED: -3001,
  KYC_PENDING: -3002,
  KYC_RETRY_REQUIRED: -3003,
  KYC_REJECTED: -3004,
  KYC_STATUS_UNAVAILABLE: -3005,
  KYC_SERVICE_UNAVAILABLE: -3008,
  KYC_SHARE_RECIPIENT_MISSING: -7003,
  KYC_SHARE_FAILED: -7004,
  KYC_SHARE_PENDING: -7005,
  TX_CONFLICT: -6001,
});
